import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-white overflow-hidden" data-id="element-179">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-180"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/50 to-white" data-id="element-181"></div>

      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10" data-id="element-182">
        <div className="max-w-4xl" data-id="element-183">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium mb-6 border border-blue-100" data-id="element-184">
            <span className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" data-id="element-185"></span>
            AI Automation & Growth Consulting
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 tracking-tight leading-tight" data-id="element-186">
            Automate operations. <br className="hidden md:block" data-id="element-187" />
            Accelerate growth. <br className="hidden md:block" data-id="element-188" />
            <span className="text-blue-600" data-id="element-189">Outpace the competition.</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl leading-relaxed" data-id="element-190">
            We help mid-market companies deploy AI to streamline processes,
            optimize revenue engines, and drive measurable business outcomes.
            Stop experimenting and start scaling.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-191">
            <a href="#contact" className="px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 font-semibold shadow-lg shadow-blue-600/20" data-id="element-192">
              Book a Strategy Call <ArrowRightIcon size={18} data-id="element-193" />
            </a>
            <a href="#services" className="px-8 py-4 bg-white text-gray-800 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors flex items-center justify-center font-medium" data-id="element-194">
              See Our Services
            </a>
          </div>
        </div>
      </div>
    </section>;
}